import React from "react";
import styled from "styled-components";

import RolePicker from "../RolePicker";
import type { OfferWheelLayout } from "../useOfferWheelLayout";
import type { OfferRecipientState } from "../types";

interface RoleStepProps {
  roleId?: number;
  onChange: (roleId: number, info: { roleNameJp: string }) => void;
  /**
   * arc モード時に Stage 余白がクリックされたときの「ロール未選択へ戻す」コールバック。
   * 旧 coverflow の handleWrapperClick と同等の挙動を arc 版でも提供するための導線。
   */
  onDeselect?: () => void;
  /** Shift ホールドのスタックプレビュー開始 / 解除通知（副パネルを隠す用途）。 */
  // eslint-disable-next-line no-unused-vars
  onStackChange?: (active: boolean) => void;
  /** カードのダブルクリック / Enter で「次へ」相当の決定を行う。 */
  onConfirmSelection?: () => void;
  /** arc モードのカード寸法 / 縦中心（空き領域へフィットさせた値）。 */
  wheelLayout?: OfferWheelLayout | null;
  /**
   * 受信者の現在の選択。`mode === "follows"` で `userId` が決まっている場合のみ
   * `RolePicker` 側で「そのユーザーがアクティブにしているロール」に絞り込む。
   */
  recipient?: OfferRecipientState;
  /** RolePicker の表示モード（"list" | "arc"）。 */
  variant?: "list" | "arc";
  /** arc モードでの「再クリック → クレジット名表示」トグル状態（親で保持）。 */
  showCreditTitle?: boolean;
  onShowCreditTitleChange?: (next: boolean) => void;
}

const StepRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const RoleStep: React.FC<RoleStepProps> = ({
  roleId,
  onChange,
  onDeselect,
  onStackChange,
  onConfirmSelection,
  wheelLayout,
  recipient,
  variant,
  showCreditTitle,
  onShowCreditTitleChange,
}) => {
  const filterByUserId =
    recipient?.mode === "follows" && recipient.userId !== undefined
      ? recipient.userId
      : undefined;
  return (
    <StepRoot>
      <RolePicker
        value={roleId}
        onChange={onChange}
        onDeselect={onDeselect}
        onStackChange={onStackChange}
        onConfirmSelection={onConfirmSelection}
        wheelLayout={wheelLayout}
        filterByUserId={filterByUserId}
        variant={variant}
        showCreditTitle={showCreditTitle}
        onShowCreditTitleChange={onShowCreditTitleChange}
      />
    </StepRoot>
  );
};

export default RoleStep;
